<template>
  <div class="counter">
    <span class="numerator">{{ prevAndCurrentTicketsCount }}件</span>
    <span>/</span>
    <span class="denominator">{{ totalGiftTicketsCount }}件</span>
  </div>
</template>

<script>
export default {
  props: {
    prevAndCurrentTicketsCount: {
      type: Number,
      required: true
    },
    totalGiftTicketsCount: {
      type: Number,
      required: true
    }
  }
}
</script>
